// NotePage.js
import React, { useState } from 'react';
import axios from 'axios';
import './NoteDisplay.css';

const NotePage = () => {
  const [noteId, setNoteId] = useState(''); // State for storing entered note ID
  const [note, setNote] = useState(null);   // State for storing retrieved note
  const [loading, setLoading] = useState(false); // State for loading indication

  // Function to retrieve note content from IPFS
  const retrieveFromIPFS = async (ipfsHash) => {
    const url = `https://ipfs.io/ipfs/${ipfsHash}`;

    try {
      const response = await axios.get(url);
      return response.data.note; // Assuming the note is stored in JSON under 'note'
    } catch (error) {
      console.error('Error retrieving from IPFS: ', error);
      return null;
    }
  };

  // Function to handle note ID submission
  const handleRetrieveNote = () => {
    setLoading(true);
    
    // Retrieve stored notes from localStorage
    const storedNotes = JSON.parse(localStorage.getItem('notes')) || [];
    
    // Find the note with the entered ID
    const noteToRetrieve = storedNotes.find((n) => n.id === noteId);
    
    if (noteToRetrieve) {
      // Retrieve note content from IPFS
      retrieveFromIPFS(noteToRetrieve.ipfsHash).then((content) => {
        setNote({
          title: noteToRetrieve.title,
          content: content,
        });
        setLoading(false);
      });
    } else {
      setNote(null);
      setLoading(false);
    }
  };

  return (
    <div>
      
      <div className='Main'>
      <h1>Retrieve Note by ID</h1>
      </div>
      
      {/* Input for Note ID */}
      <div className='retrieve'>
      <input 
        type="text" 
        placeholder="Enter Note ID" 
        value={noteId} 
        onChange={(e) => setNoteId(e.target.value)}
      />
      
      <button onClick={handleRetrieveNote}>Retrieve Note</button>
      </div>
      
      {loading && <p>Loading...</p>}
      
      {/* Display retrieved note */}
      {note && (
        <div className="container">
          <h2 className="title">{note.title}</h2>
          <p className="content">{note.content}</p>
        </div>
      )}

      {/* Display message if no note is found */}
      {/* {!loading && note === null && (
        <p>No note found with the current entered ID.</p>
      )} */}
    </div>
  );
};

export default NotePage;
